import { render, staticRenderFns } from "./HerouxTrade.vue?vue&type=template&id=30652b40&"
import script from "./HerouxTrade.vue?vue&type=script&lang=js&"
export * from "./HerouxTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports